import React from 'react';
import PropTypes from 'prop-types';
import HoverButton from './HoverButton';
import ButtonBox from './ButtonBox';

/**
 * MemberButtonBox holds the Member buttons, which are hoverable.
 *
 * @reactProps {string} classname - the className to control style
 * @reactProps {function} onEvent - a handle function (handleFieldChange)
 */
export default class MemberButtonBox extends React.Component {
  /**
   * stores the value of selected
   */
  state = {};

  /**
   * Highlight sets the string it is passed to state.
   * When HoverButtons are created the boolean selected
   * passed as a prop is set to wether the HoverButton
   * value === this.state.selected
   */
  highlight = value => {
    this.setState({ selected: value });
  };

  /**
   * Renders
   * @return a ButtonBox, passes ButtonBox an Array of HoverButtons
   */
  render() {
    return (
      <div>
        <ButtonBox
          classname={this.props.classname}
          title="Members"
          buttons={Array.from({ length: 18 }).map((_, i) => {
            i += 1;
            return (
              <HoverButton
                key={i}
                label={'Member ' + i}
                value={i < 10 ? 'member_0' + i : 'member_' + i}
                onEvent={this.props.onEvent}
                highlight={this.highlight}
                selected={
                  (i < 10 ? 'member_0' + i : 'member_' + i) ===
                  this.state.selected
                }
              />
            );
          })}
          closable={true}
        />
      </div>
    );
  }
}

MemberButtonBox.propTypes = {
  classname: PropTypes.string,
  onEvent: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/MemberButtonBox.js